import { TableCell, TableRow, Typography } from '@mui/material';

/** Shared SSCM table-empty pattern for Recipe V2 tabular sections. */
const RecipeV2EmptyState = ({ children, colSpan }: { children: string; colSpan: number }) => (
  <TableRow>
    <TableCell colSpan={colSpan}
      align="center"
      sx={{ py: 6 }}>
      <Typography color="text.secondary"
        variant="textSM">
        {children}
      </Typography>
    </TableCell>
  </TableRow>
);

export default RecipeV2EmptyState;
